import { ProfileDropdown } from './ProfileDropdown';
import { Link } from 'react-router-dom';
// Temporarily unused while station selector is hidden
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from './ui/select';
import type { Location } from '../lib/supabase';

interface HeaderProps {
  locations: Location[];
  selectedLocation: string;
  onLocationChange: (value: string) => void;
  isLoading: boolean;
  logoClickable?: boolean;
}

export function Header({
  locations: _locations,
  selectedLocation: _selectedLocation,
  onLocationChange: _onLocationChange,
  isLoading: _isLoading,
  logoClickable = true,
}: HeaderProps) {
  const logo = (
    <img
      src="/HyroxLogo.png"
      alt="Hyrox Logo"
      className="h-9 w-auto object-contain"
    />
  );

  return (
    <header className="pen-topbar font-brutal">
      <div className="min-w-0 flex-shrink-0">
        {logoClickable ? (
          <Link to="/dashboard" className="block hover:opacity-80 transition-opacity">
            {logo}
          </Link>
        ) : (
          logo
        )}
      </div>

      <div className="ml-auto flex items-center gap-2">
        {/* Temporarily hidden — station is set via Set Station screen
        <Select value={selectedLocation} onValueChange={onLocationChange} disabled={isLoading}>
          <SelectTrigger className="h-auto min-h-0 w-auto max-w-[140px] bg-black border border-sw-border rounded-sm px-2.5 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.03em] text-white focus:ring-1 focus:ring-sw-yellow [&>svg]:text-sw-yellow [&>svg]:opacity-100">
            <SelectValue placeholder="Location" />
          </SelectTrigger>
          <SelectContent className="bg-sw-panel border-sw-border text-white font-brutal">
            {locations.map((location) => (
              <SelectItem
                key={location.locationid}
                value={location.locationid.toString()}
                className="text-xs uppercase focus:bg-sw-yellow focus:text-black"
              >
                {location.locationname || `Location ${location.locationid}`}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        */}
        <ProfileDropdown variant="pen" />
      </div>
    </header>
  );
}
